//Built-in libraries
import type { ColumnDef } from '@tanstack/react-table';
import { useState } from 'react';
import Card from '@/components/UI/Card/index.tsx';
//Custom components
import Table from '@/components/UI/Table';

//Services

//Assets and Miscellaneous

interface DistrictBreakdownDeniedProps {
  data: Array<{
    name: string;
    projects: number;
  }>;
}
const DistrictBreakdownDeniedWidget = ({ data }: DistrictBreakdownDeniedProps) => {
  const [perPage, setPerPage] = useState<number>(10);
  const [page, setPage] = useState<number>(1);
  const [totalPage, _setTotalPage] = useState<number>(1);

  const nextPageHandler = () => {
    setPage((prevState) => (prevState === totalPage ? totalPage : page + 1));
  };

  const previousPageHandler = () => {
    setPage((prevState) => (prevState > 1 ? page - 1 : 1));
  };

  const tableColumns: ColumnDef<any>[] = [
    {
      id: 'name',
      header: 'District',
      accessorKey: 'name',
      cell: (props) => {
        const { getValue } = props;
        return getValue();
      },
    },
    {
      id: 'projects',
      header: () => <div>Projects</div>,
      accessorKey: 'projects',
      cell: (props) => {
        const { getValue } = props;
        return (
          <div>
            <span>{getValue() as number}</span>
          </div>
        );
      },
    },
  ];

  const tablePagination = {
    page: page,
    pageSize: perPage,
    pageCount: totalPage,
    currentPage: page,
    setPageSize: (v: number) => setPerPage(v),
    nextPage: nextPageHandler,
    previousPage: previousPageHandler,
  };

  return (
    <Card title='District Breakdown - Denied'>
      {data && (
        <div className='h-full w-full'>
          <div className='h-96 border rounded-b-md w-full'>
            <Table cols={tableColumns} tableData={data} pagination={tablePagination} height='h-5/6' />
          </div>
        </div>
      )}
    </Card>
  );
};

export default DistrictBreakdownDeniedWidget;
